import React from "react";
import { Box, Image, Text } from "@chakra-ui/react";
import BuyTicket from "../images/Background/BuyTicket.png";
import BuyTicketMono from "../images/Background/BuyTicketMono.png";

interface CommonImageProps {
  onContextMenu: (e: { preventDefault: () => void }) => void;
  draggable: boolean;
}

const preventDefault = (e: { preventDefault: () => void }): void => {
  e.preventDefault();
};

const commonImageProps: CommonImageProps = {
  onContextMenu: preventDefault,
  draggable: false,
};

interface TicketButtonProps {
  text: string;
  color: string;
  isActive?: boolean;
  onClick?: () => void;
  href?: string;
  target?: string;
  rel?: string;
}

// チケットボタン用の共通スタイル
const ticketButtonStyles = {
  color: "white",
  width: {
    base: "240px",
    sm: "280px",
    md: "400px",
    lg: "600px",
    xl: "600px",
  },
  px: 8,
  py: 2,
  borderRadius: "2xl",
  fontSize: "20px",
  fontWeight: "bold",
  mt: {
    base: 4,
    sm: 4,
    md: 6,
    lg: 6,
    xl: 8,
    "2xl": 8,
  },
};

// チケットボタンのテキストスタイル
const ticketButtonTextStyles = {
  position: "absolute" as const,
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  fontSize: {
    base: "10px",
    sm: "13px",
    md: "20px",
    lg: "33px",
    xl: "33px",
  },
  fontWeight: "bold",
  zIndex: 1,
};

const TicketButton: React.FC<TicketButtonProps> = ({
  text,
  color,
  isActive = true,
  onClick,
  href,
  target,
  rel,
}) => {
  const buttonProps = href
    ? {
        as: "a" as const,
        href,
        target,
        rel,
        _hover: { opacity: 0.8 },
        display: "block",
        textDecoration: "none",
      }
    : {
        display: "block",
      };

  return (
    <Box {...ticketButtonStyles} {...buttonProps} onClick={onClick}>
      <Box position="relative">
        <Image
          src={isActive ? BuyTicket : BuyTicketMono}
          alt="apply ticket"
          w={{
            base: "95%",
            sm: "95%",
            md: "95%",
            lg: "95%",
            xl: "95%",
          }}
          h="auto"
          maxW={{
            base: "150px",
            sm: "180px",
            md: "250px",
            lg: "400px",
            xl: "400px",
          }}
          mx="auto"
          {...commonImageProps}
        />
        <Text {...ticketButtonTextStyles} color={color}>
          {text}
        </Text>
      </Box>
    </Box>
  );
};

export default TicketButton;
